export default __webpack_public_path__ + "73174ef8b94175ba041db8c72e56ca66.svg";